<template>
  <el-container>
    <el-main style="padding: 0;">
      <span>上料验证扫描</span>
      <el-divider/>
      <el-form
          ref="form"
          style="width: 500px"
          :model="model"
          class="form"
          :rules="ruleValidate"
          label-width="80px">
        <el-form-item label="关联编号" prop="orderNo">
          <el-input ref="orderNoInput" v-model="model.orderNo" placeholder="请扫描工单号或工单的物料条码" @keyup.enter.native="scanOrderNo"/>
        </el-form-item>
        <el-form-item label="物料编号" prop="strNo">
          <el-input 
              ref="strNoInput" 
              v-model="model.strNo" 
              placeholder="请扫描物料编码" 
              @keyup.enter.native="scanHandle"
              @focus="selectContent($event)"/>
        </el-form-item>
        <el-form-item>
          <el-button type="info" @click="reset">重置</el-button>
          <el-button type="primary" @click="scanHandle">确认</el-button>
        </el-form-item>
      </el-form>
      <span>上料记录</span>
      <el-divider/>
      <vm-table
          ref="vmTable"
          :filter.sync="filter"
          :columns-btn-show="false"
          module="basic"
          url="scanRecords">
        <el-table-column prop="repairOrder" align="center" label="工单编号" min-width="150"/>
        <el-table-column prop="insertTypeName" align="center" label="扫描类型" min-width="150"/>
        <el-table-column prop="outboundState" align="center" label="类型" min-width="150"/>
        <el-table-column prop="creatorName" align="center" label="创建人" min-width="150"/>
        <el-table-column prop="addDate" align="center" label="创建时间" min-width="150"/>
      </vm-table>
    </el-main>
  </el-container>
</template>

<script>
  import VmTable from "@/components/VmTable.vue";
  export default {
    name: "LoadMaterialScanIndex",
    components: {
      VmTable,
    },
    
    data() {
      return {
        model: {
          orderNo: "",
          strNo: "",
        },
        filter: {
          insertType: 2,
        },
        ruleValidate: {
          orderNo: [{ required: true, message: "请扫描工单号或工单的物料条码", trigger: "change" }],
          strNo: [{ required: true, message: "请扫描物料编码", trigger: "change" }],
        },
      };
    },

    mounted() {
      this.$refs.vmTable.getList(1);
      this.$refs.orderNoInput.focus();
    },

    methods: {
      scanHandle() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.$http.post("basic", "productionScan/scanPrepare", this.model).then((resp) => {
              if (resp.success) {
                this.$message.success("上料成功");
                this.$refs.vmTable.getList(1);
                this.reset();
              }
            }).catch(()=>{
              this.$refs.strNoInput.focus();
            });
          }
        });
      },

      // 扫描关联编号
      scanOrderNo() {
        if (this.model.orderNo) {
          this.$refs.strNoInput.focus();
        }
      },

      reset() {
        this.$refs["form"].resetFields();
        this.$refs.orderNoInput.focus();
      },

      selectContent(e) {
        e.currentTarget.select();
      },
    },
  };
</script>
